// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".right-bar.white-theme .theme--light.v-tabs>.v-tabs-bar{background-color:#e1e1e1 !important}.right-bar.white-theme .theme--light.v-tabs-items{background-color:#e1e1e1 !important;border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem}.v-tabs.bet-tablist{border-top-left-radius:.5rem;border-top-right-radius:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
